var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.baseClass,
    { 'bg-gray-100 cursor-not-allowed opacity-75' : _vm.disabled },
    { 'ring-2' : _vm.isActive }
  ]},[_vm._t("default",function(){return [(_vm.value)?[_c('div',{staticClass:"flex items-center mr-2"},[_vm._v("\n        "+_vm._s(_vm.value)+"\n      ")])]:[_c('p',{staticClass:"text-gray-600 mr-3 leading-none"},[_vm._v("\n        "+_vm._s(_vm.placeholder)+"\n      ")])]]}),_vm._v(" "),_c('o-icon',{attrs:{"icon":"chevronDown","size":10}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }